<template lang='html'>
  <footer>
    <div class="downloads">
      <a class="button screen-only" :href="resume">
        <span class="buttonLabel">
          <img src="@/assets/img/logos/pdf.svg" />
          {{ $t('pdf.text') }}
        </span>
      </a>
      <a class="screen-only small" :href="resumeAlt">{{ $t('pdf.alt') }}</a>
    </div>
    <ul class="screen-only social">
      <li>
        <a target="_blank" href="mailto:nik.cornish@gmail.com">
          <img src="@/assets/img/logos/email.svg" />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://telegram.me/nikcornish">
          <img src="@/assets/img/logos/telegram.svg" />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.linkedin.com/in/nikcornish/">
          <img src="@/assets/img/logos/linkedin.svg" />
        </a>
      </li>
      <li>
        <a target="_blank" href="https://www.xing.com/profile/Nik_Cornish/cv">
          <img src="@/assets/img/logos/xing.svg" />
        </a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    isEN() {
      return this.$i18n.locale === 'en';
    },
    resume() {
      let pdf = '';
      if (this.isEN) {
        pdf = require('../assets/pdfs/nikcornish_resume.pdf');
      } else {
        pdf = require('../assets/pdfs/nikcornish_lebenslauf.pdf');
      }
      return pdf;
    },
    resumeAlt() {
      let pdf = '';
      if (this.isEN) {
        pdf = require('../assets/pdfs/nikcornish_lebenslauf.pdf');
      } else {
        pdf = require('../assets/pdfs/nikcornish_resume.pdf');
      }
      return pdf;
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  display: grid;
  justify-items: center;
  // margin: ms(1) 0 ms(4) 0;
  ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    justify-items: center;
    margin-top: ms(1);
    li {
      align-self: center;
    }
  }

  @media print {
    width: 100%;
    display: grid;
    ul {
      display: block;
      font-size: 12px;
      align-content: start;
    }
  }
  .button {
    border: none;
    text-decoration: none;
    text-align: center;
    display: block;
    padding: ms(1);
    color: white;
    background-color: black;
    border-radius: 4px;
    width: 100%;
    @media screen and (min-width: 720px) {
      max-width: 420px;
    }
    &:visited {
      color: white;
    }
    .buttonLabel {
      display: grid;
      grid-template-columns: min-content max-content;
      grid-gap: ms(0);
      justify-content: center;
      align-items: center;
    }
  }
  .downloads {
    display: grid;
    width: 100%;
    margin-top: ms(1);
    @media screen and (min-width: 768px) {
      justify-content: center;
      width: 50%;
    }
    a {
      display: block;
      text-align: center;
    }
    .small {
      font-size: ms(-1);
      margin-top: ms(1);
    }
  }
  .social {
    margin: ms(2) auto;
  }
}
</style>
